<template>
    <div class="input-container">
        <div class="input-title">{{ title }}</div>
        <div class="input-box input-stripe">
            <input type="hidden" name="stripe_token" v-model="token.id">
            <card
                :class="{ complete }"
                :stripe="stripe"
                :options="options"
                @change="complete = $event.complete"
            ></card>
        </div>
    </div>
</template>

<script>

import { Card, createToken } from 'vue-stripe-elements-plus';
import axios from 'axios';

if (!process.env.MIX_STRIPE_KEY) {
    console.warn('There is no stripe token specified');
}

export default {

    props: {
        title: {
            type: String,
            default: 'Credit Card'
        },
    },

    data() {
        return {
            loading: false,
            formData: {},
            stripe: process.env.MIX_STRIPE_KEY,
            options: {},
            token: {},
            complete: false,
        };
    },

    computed: {

        isComplete() {
            return this.complete;
        },
    },

    watch: {
        formData(newValue, oldValue) {
            this.$emit('input', this.formData);
        },

        isComplete(newValue, oldValue) {
            if (newValue && !oldValue) {
                // Get token
                this.create();
            }
        }
    },

    methods: {


        create() {
            if (!this.isComplete) return;

            this.loading = true;
            createToken().then(({ token }) => {
                this.loading = false;
                this.token = token;
                this.$emit('completed', token);

                // axios.post('/billing/start-subscription', { token });

            });
        },
    },

    components: {
        Card,
    },

}


</script>



// WEBPACK FOOTER //
// resources/js/components/billing/CardForm.vue